import React from "react";
import "./partner.css";

const logos = [
  "amazon.png",
  "adani.png",
  "dextrus.jpg",
  "Homi_Bhabha_National_Institute_logo.png",
  "firstTime.png",
  "jioWorldGarden.png",
  "jswSteel.png",
  "csmia.png",
  "atl.png",
  "runwal-logo.png",
  "l&t.png",
];

export default function Partners() {
  return (
    <section className="partners-wrapper">
      <h3>Our Clients</h3>
      <div className="client-logo-grid">
        {logos.map((logo, index) => (
          <div className="client-grid-item" key={index}>
            <img
              src={`./images/${logo}`}
              alt={`client-logo-${index + 1}`}
              className="logo-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
